import { http } from '@/api/client/httpClient';
import { createAbpCrudService } from '@/api/abpCrudService';
import type {
  CreateEmailRecipientDto,
  EmailRecipientDatatableInput,
  EmailRecipientDto,
  EmailRecipientGroupSettingDto,
  SetEmailRecipientGroupModeDto,
  UpdateEmailRecipientDto,
} from '@/api/types/emailRecipients';

// Finkit.Tenants.Admin.EmailRecipients.EmailRecipientsAppService at
// /api/app/email-recipients — standard CRUD (factory) + group-settings extras.
const BASE = '/api/app/email-recipients';

export const emailRecipientsApi = {
  ...createAbpCrudService<EmailRecipientDto, CreateEmailRecipientDto, UpdateEmailRecipientDto, EmailRecipientDatatableInput>(
    BASE,
  ),

  async getGroupSettings(): Promise<EmailRecipientGroupSettingDto[]> {
    const { data } = await http.get<EmailRecipientGroupSettingDto[]>(`${BASE}/group-settings`);
    return data;
  },

  async setGroupMode(input: SetEmailRecipientGroupModeDto): Promise<void> {
    await http.post(`${BASE}/set-group-mode`, input);
  },
};
